import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import configData from "../../config/config.json";
import { handleError } from '../../redux/actions/commonStuff';

export default function ContactUsSmall({
  isOpen,
  onToggle,
  endpoint = "home/all",
  redirectOnAuthError = true,
}) {
  const history = useHistory();

  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");

  useEffect(() => {
    const loadContactUs = async () => {
      try {
        const response = await axios.get(configData.LANDNOTIFICATION_SERVER_URL + endpoint, { withCredentials: true });
        const content = response.data.content;
        setContactEmail(content.common.contactEmail);
        setContactPhone(content.common.contactPhone);
      } catch (error) {
        if (redirectOnAuthError) {
          handleError(error, history);
        } else {
          console.error("Failed to load contact us:", error);
        }
      }
    };

    loadContactUs();
  }, [history, endpoint, redirectOnAuthError]);

  return (
    <div
      style={{
        ...styles.container,
        boxShadow: isOpen
          ? "0 4px 10px rgba(0,0,0,0.08)"
          : "0 1px 3px rgba(0,0,0,0.05)",
      }}
    >
      {/* Header */}
      <div
        style={{
          ...styles.header,
          backgroundColor: isOpen ? "#5A6268" : "#6C757D",
        }}
        onClick={onToggle}
      >
        <span>Contact Us</span>

        {/* Arrow with smooth rotation */}
        <span
          style={{
            ...styles.icon,
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            display: "inline-block",
          }}
        >
          ▼
        </span>
      </div>

      {/* Animated Content */}
      <div
        style={{
          ...styles.wrapper,
          maxHeight: isOpen ? "300px" : "0px",
        }}
      >
        <div
          style={{
            ...styles.content,
            opacity: isOpen ? 1 : 0,
            transition: "opacity 0.2s ease 0.08s",
          }}
        >
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <span style={styles.label}>Email:</span> <a href={`mailto:${contactEmail}`} style={styles.link}>{contactEmail}</a>
            </li>
            <li style={styles.listItem}>
              <span style={styles.label}>Phone:</span> <a href={`tel:${contactPhone.replace(/[^\d+]/g, "")}`} style={styles.link}>{contactPhone}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

// Styles
const styles = {

  container: {
    marginTop: "16px",
    border: "2px solid #6C757D",
    borderRadius: "6px",
    overflow: "hidden",
    transition: "box-shadow 0.3s ease",
    boxShadow: "0 4px 12px rgba(108, 117, 125, 0.12)",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 12px",
    cursor: "pointer",
    backgroundColor: "#6C757D",
    fontWeight: "bold",
    color: "white",
    transition: "background-color 0.2s ease",
  },

  icon: {
    fontSize: "12px",
  },

  wrapper: {
    overflow: "hidden",
    transition: "max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
  },

  content: {
    padding: "12px",
    backgroundColor: "white",
    fontSize: "14px",
    lineHeight: "1.5",
  },

  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },

  listItem: {
    color: "#444",
    fontSize: "14px",
    lineHeight: "1.6",
  },

  label: {
    fontWeight: "bold",
    color: "#444",
  },

  link: {
    color: "#114E6B",
    fontWeight: "bold",
    textDecoration: "underline",
  },

};
